import React, { useEffect, useState } from 'react'
import styles from '../../sass/checkout.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { IMG, Icons } from '../../constant'
import { useDispatch, useSelector } from 'react-redux'
import { formatIndianNumber } from '../../utils'
import { toast } from 'react-toastify'
import { storeOrder } from '../../redux/actions/checkoutAction'
import { emptyCart } from '../../redux/reducers/cartReducer'


const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedAddress = useSelector((state) => state.userAddress.selectedAddress);
  const { userDetails } = useSelector((state) => state.user);
  const { loader } = useSelector((state) => state.checkout);
  const { cart } = useSelector((state) => state.cart);
  const [userNote, setUserNote] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('Online');
  const [paymentCompleted, setPaymentCompleted] = useState(false);

  const handleSelect = (method) => {
    console.log("Selected Method:", method);
    if (method === 'COD' && !isCODAvailable) {
      toast.warn(codMessage);
      return; // Prevent state update
    }
    setPaymentMethod(method);
    console.log("Updated Payment Method:", method); // Check if state updates
  };

  useEffect(() => {
    console.log("UI Updated with Payment Method:", paymentMethod);
  }, [paymentMethod]);

  useEffect(() => {
    if (!paymentCompleted && (!cart?.products || cart.products.length === 0)) {
      navigate('/cart');
    }
  }, [navigate, paymentCompleted]);

 

  // Calculate discounted subtotal (this is the actual amount after discounts)
  const discountedSubtotal = cart?.total - cart?.discountedTotal;

  // Calculate delivery charges based on discounted subtotal
  const deliveryCharges = discountedSubtotal >= 2500 ? 0 : 150;

  // Determine if COD is available based on discounted subtotal
  const isCODAvailable = discountedSubtotal < 20000 && discountedSubtotal > 500;
  const codMessage = discountedSubtotal < 500 ? "COD not available for orders below ₹500" : discountedSubtotal >= 20000 ? "COD not available for orders above ₹20,000" : "COD available";

  // Calculate COD charges (5% of discounted subtotal if COD is selected)
  const codAmount = paymentMethod === 'COD' ? Math.floor(discountedSubtotal * 0.05) : 0;

  // Calculate the final total
  let total = discountedSubtotal + deliveryCharges + codAmount;

  // Round off the total value
  total = Math.round(total);

  /**
  * CHECKOUT DETAILS
  */

  const payOnline = async () => {
    const options = {
      description: 'DentalStores Order Payment',
    //   image: LOGO,
      currency: 'INR',
    //   "key": "rzp_live_UCaGUiqyAde5VK",  // Live
      key: 'rzp_test_Dor4Bw7UDtpJmH', // Replace with your Razorpay key
      amount: total * 100, // Amount in paise (5000 INR = 500000 paise)
      name: 'DentalStores.in',
      prefill: {
        email: userDetails.email,
        contact: userDetails.mobile,
        name: userDetails.name,
      },
      theme: { color: '#1565C0', hide_topbar: true },
      handler: function (response) {
        handlePaymentSuccess(response);
      },
      modal: {
        ondismiss: function () {
          toast.error("Transaction was not completed.");
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handlePaymentSuccess = (paymentData) => {
      const orderData = {
        user_id: parseInt(userDetails.id),
        payment_id: paymentData.razorpay_payment_id,
        bank_rrn: '',
        products: cart.products,
        address: selectedAddress,
        cod_amt: 0,
        total: parseFloat(cart.total), // Send MRP total like mobile app
        discountedTotal: parseFloat(cart.discountedTotal),
        totalProducts: parseInt(cart.totalProducts),
        totalQuantity: parseInt(cart.totalQuantity),
        note: userNote ?? '',
        payment_type: 'Online',
        delivery_charges: deliveryCharges ? parseFloat(deliveryCharges) : 0
      }
      dispatch(storeOrder(orderData));
      setPaymentCompleted(true);
      dispatch(emptyCart());
      navigate('/thankyou');
      toast.success('Payment successful and order placed.');
  };

  const placeCODOrder = () => {
      const orderData = {
        user_id: parseInt(userDetails.id),
        payment_id: null,
        bank_rrn: '',
        products: cart.products,
        address: selectedAddress,
        cod_amt: codAmount ? parseFloat(codAmount) : 0,
        total: parseFloat(cart.total), // Send MRP total like mobile app
        discountedTotal: parseFloat(cart.discountedTotal),
        totalProducts: parseInt(cart.totalProducts),
        totalQuantity: parseInt(cart.totalQuantity),
        note: userNote ?? '',
        payment_type: 'COD',
        delivery_charges: deliveryCharges ? parseFloat(deliveryCharges) : 0
      }
      dispatch(storeOrder(orderData));
      dispatch(emptyCart());
      setPaymentCompleted(true);
      navigate('/thankyou');
      toast.success('Your order has been placed successfully with Cash on Delivery.');
  };


  return (
    <>
        <header className={styles.Header_container}>
            <Link to={"/"} className={styles.logo_container}>
                <img alt='logo' width={200} height={50} src={IMG.logo} />
            </Link>
            <div className={styles.Header_secure}>
                <svg width="20" viewBox="0 0 20 20" color="#1565C0"><path fill="currentColor" d="M13.007 9.395L11.82 10.61l.281 1.688a.449.449 0 0 1-.189.438.516.516 0 0 1-.264.082.52.52 0 0 1-.218-.047l-1.417-.782-1.422.782a.505.505 0 0 1-.218.047.528.528 0 0 1-.265-.082.455.455 0 0 1-.188-.438l.281-1.688-1.183-1.215c-.125-.113-.155-.293-.109-.456a.441.441 0 0 1 .357-.305l1.623-.245.7-1.494a.455.455 0 0 1 .406-.259c.172 0 .328.1.408.259l.7 1.494 1.622.245c.172.03.31.146.357.305a.48.48 0 0 1-.075.456M9.943 2C9.81 2.056 3 4.62 3 4.623v4.819c0 3.34.977 7.705 6.943 9.329 5.951-1.624 6.928-6.065 6.928-9.33.014-1.647.014-4.818.014-4.818 0-.004-6.77-2.557-6.942-2.623"></path></svg>
                <span className={styles.Header_secureText}>100% Secure Payments</span>
            </div>
        </header>

        <div className={styles.Content_wrapper}>
            <div className={styles.Content_container}>
                <div className={styles.LHS_container}>
                    <div className={`${styles.deliveryWrapper} ${styles.wrapper}`}>
                        <div className={styles.headingWrapper}>
                            <h6 className={styles.heading}>Delivery Address</h6>
                        </div>
                        <div className={styles.bodyWrapper}>
                            <div className={styles.contentWrapper}>
                                <div className={styles.AddressCard_addressDetails}>
                                    <p className={styles.AddressCard_addName}>{selectedAddress.fname} {selectedAddress.lname}</p>
                                    <p>
                                        {selectedAddress.address} <br />
                                        {selectedAddress.city}, {selectedAddress.state_name} <br />
                                        {selectedAddress.country_name} - {selectedAddress.pincode}.
                                    </p>
                                    <p>Phone: {selectedAddress.phone} {selectedAddress.alt_phone !== null ? ` / ${selectedAddress.alt_phone}` : ''}</p>
                                    <p style={{ marginBlock: 5 }}><b>Landmark: </b> {selectedAddress.landmark}</p>
                                    {selectedAddress.gstin !== null ? <p>GSTIN: {selectedAddress.gstin}</p> : null }
                                    {selectedAddress.dla !== null ? <p>Drug License: {selectedAddress.dla}</p> : null }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.lhsTitle}>Payment Options</div>
                    {['Online', 'COD'].map((method) => (
                        <div
                            key={method}
                            className={`${styles.paymentOptionContainer} ${paymentMethod === method ? styles.paymentOptionSelected : ''}`}
                            onClick={() => handleSelect(method)}
                        >
                            {/* Radio Button */}
                            <div className={`${styles.radioButton} ${paymentMethod === method ? styles.radioButtonSelected : ''}`}>
                            {paymentMethod === method && <div className={styles.radioButtonInner} />}
                            </div>

                            <span className={`${styles.paymentText} ${paymentMethod === method ? styles.paymentTextSelected : ''}`}>{method}</span>
                        </div>
                    ))}

                    <div>
                        {/* Online Payment Details */}
                        {paymentMethod === "Online" && (
                            <div className={`${styles.deliveryWrapper} ${styles.wrapper}`}>
                            <div className={styles.headingWrapper}>
                                <h6 className={styles.heading}>Pay Online using UPI, Debit/Credit Card, Netbanking, Wallet, EMI.</h6>
                            </div>
                            <div className={styles.bodyWrapper}>
                                <div className={styles.contentWrapper}>
                                    <div className={styles.UserNote_wrapper}>
                                        <div className={styles.UserNote_title}>Add a Note (Optional)</div>
                                        <textarea 
                                            className={styles.UserNote_textbox} 
                                            placeholder="Add special instructions or requests..."
                                            value={userNote}
                                            onChange={(e) => setUserNote(e.target.value)}
                                        >{userNote}</textarea>
                                    </div>
                                    {paymentMethod === 'Online' ? (
                                    selectedAddress && Object.keys(selectedAddress).length > 0 ?
                                    ( 
                                        <button 
                                            type={loader ? "button" : "submit"}
                                            disabled={loader}
                                            style={loader ? {opacity: 0.5} : {opacity: 1}}
                                            onClick={payOnline} className={styles.payCta}
                                        >{loader ? "Please wait..." : "Pay Online"}</button> 
                                    ) : <button onClick={ () => navigate('/cart')}>+ Add new address</button>
                                    
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        )}

                        {paymentMethod === "COD" && (
                            <div className={`${styles.deliveryWrapper} ${styles.wrapper}`}>
                            <div className={styles.headingWrapper}>
                                <h6 className={styles.heading}>Cash On Delivery <small>(Available for orders below ₹20,000 and above ₹500)</small></h6>
                            </div>
                            <div className={styles.bodyWrapper}>
                                <div className={styles.contentWrapper}>
                                    <div className={styles.CODAdv_wrapper}>
                                        All COD orders need to pay small advance payment to avoid fake orders and to minimise cancel orders / order getting returned. The rest of the COD payment can be done at the time of delivery. This will avoid our shipping costs losses and we can continue offering prices to our customers at lowest prices as usual. Our team will contact you for making advance payment soon.
                                    </div>
                                    <div className={styles.COD_wrapper}>
                                        <p className={styles.COD_title}>Why 5% extra on COD?</p>
                                        <ul className={styles.COD_list}>
                                            <li>
                                                Logistics / Courier charges us 5% extra for COD shipments. Since we work on very low
                                                profit margins, we have to pass the charges on to our customers. To save 5% extra charges,
                                                customers are advised to pay upfront at the time of ordering.
                                            </li>
                                            <li>
                                                All COD orders need to pay a small advance payment to avoid fake orders and minimize
                                                cancellations/orders getting returned. The rest of the COD payment can be done at the
                                                time of delivery. This will avoid shipping cost losses, allowing us to continue offering
                                                products at the lowest prices. Our team will contact you soon for making the advance payment.
                                            </li>
                                        </ul>
                                        <p className={styles.COD_note}>
                                            <span>Please note:</span> Without receiving advance payment, we will not ship COD orders.
                                        </p>
                                    </div>
                                    <div className={styles.UserNote_wrapper}>
                                        <div className={styles.UserNote_title}>Add a Note (Optional)</div>
                                        <textarea 
                                            className={styles.UserNote_textbox} 
                                            placeholder="Add special instructions or requests..."
                                            value={userNote}
                                            onChange={(e) => setUserNote(e.target.value)}
                                        >{userNote}</textarea>
                                    </div>
                                    {paymentMethod === 'COD' ? (
                                        selectedAddress && Object.keys(selectedAddress).length > 0 ?
                                    ( 
                                        <button 
                                            type={loader ? "button" : "submit"}
                                            disabled={loader}
                                            style={loader ? {opacity: 0.5} : {opacity: 1}}
                                            onClick={placeCODOrder} className={styles.payCta}
                                        >{loader ? "Please wait..." : "Place COD Order"}</button> 
                                    ) : <button onClick={ () => navigate('/cart')}>+ Add new address</button>
                                    
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        )}

                        {/* COD Payment Details */}
                        {paymentMethod === "COD" && (
                            <div className="p-4 bg-gray-100 rounded-lg" style={{ display: 'none' }}>
                            <p></p>
                            <p className="text-red-600 font-semibold">* 5% extra applicable on COD.</p>
                            <p className="font-semibold mt-2">Why 5% extra on COD?</p>
                            <p className="">
                                Logistics / Courier charges us 5% extra for COD shipments. Since we work on very low
                                profit margins, we have to pass the charges on to our customers. To save 5% extra charges,
                                customers are advised to pay upfront at the time of ordering.
                            </p>
                            <p className="">
                                All COD orders need to pay a small advance payment to avoid fake orders and minimize
                                cancellations/orders getting returned. The rest of the COD payment can be done at the
                                time of delivery. This will avoid shipping cost losses, allowing us to continue offering
                                products at the lowest prices. Our team will contact you soon for making the advance payment.
                            </p>
                            <p className="">
                                Please note: Without receiving advance payment, we will not ship COD orders.
                            </p>
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.RHS_container}>
                    <div className={styles.BillSummarySection_billSummaryWrapper}>
                        <div className={styles.BillSummarySection_billSummaryContainer}>
                        <div className={styles.BillSummarySection_ellipseTop} style={{ backgroundImage: `url(${IMG.ellipseWhite})` }}></div>
                        <div className={styles.BillSummarySection_commBifurcationWrapper}>
                            <div className={styles.CommonBifurcation_wrapper}>
                            <div className={styles.CommonBifurcation_billSummaryCard}>
                                <h1 className={styles.CommonBifurcation_billSummaryTitle}>Bill Summary</h1>
                                <div className={styles.BifurcationV2_bifurcationContainer}>
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={styles.BifurcationV2_billSummaryText}>
                                    <span>MRP</span>
                                    </div>
                                    <div>
                                    <span className={styles.BifurcationV2_billSummaryFinalValue}>₹{formatIndianNumber(cart?.total)}</span>
                                    </div>
                                </div>
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={styles.BifurcationV2_billSummaryText}>
                                    <span>Discount</span>
                                    </div>
                                    <div>
                                    <span className={`${styles.BifurcationV2_billSummaryFinalValue} ${styles.BifurcationV2_green}`}>-₹{formatIndianNumber(cart?.discountedTotal)}</span>
                                    </div>
                                </div>
                                </div>
                                <div className={styles.BifurcationV2_bifurcationContainer}>
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={styles.BifurcationV2_billSummaryText}>
                                    <span>Discounted Value</span>
                                    </div>
                                    <div>
                                    <span className={styles.BifurcationV2_billSummaryFinalValue}>₹{formatIndianNumber(cart?.total - cart?.discountedTotal)}</span>
                                    </div>
                                </div>
                                {paymentMethod === "COD" && (
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={`${styles.BifurcationV2_billSummaryText} ${styles.BifurcationV2_billSummaryText_COD}`}>
                                    <span>Extra applicable on COD (5%)</span>
                                    </div>
                                    <div>
                                    <span className={`${styles.BifurcationV2_billSummaryFinalValue} ${styles.BifurcationV2_billSummaryFinalValue_COD}`}>₹{formatIndianNumber(codAmount)}</span>
                                    </div>
                                </div>
                                )}
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={styles.BifurcationV2_billSummaryText}>
                                    <span>Delivery Fee</span>
                                    </div>
                                    <div>
                                    <span className={styles.BifurcationV2_billSummaryFinalValue}>
                                    {discountedSubtotal >= 2500 ? <><span className={styles.BifurcationV2_strike}>₹150.00</span> <span className={styles.BifurcationV2_green}>FREE</span></> : `₹${deliveryCharges}`}
                                    </span>
                                    </div>
                                </div>
                                </div>
                                <div className={styles.BifurcationV2_bifurcationContainer}>
                                <div className={styles.BifurcationV2_bifurcateRow}>
                                    <div className={`${styles.BifurcationV2_billSummaryText} ${styles.BifurcationV2_amountToBePaid}`}>
                                    <span>Amount to be paid</span>
                                    </div>
                                    <div>
                                    <span className={`${styles.BifurcationV2_billSummaryFinalValue} ${styles.BifurcationV2_finalValueBold}`}>₹{formatIndianNumber(total)}</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className={styles.CommonSavingsBifurcation_savingsBifurcation}>
                                <div className={styles.CommonSavingsBifurcation_savingsContainer}>
                                <div className={styles.CommonSavingsBifurcation_titleContainer}>
                                    <img width={24} height={24} alt='icon' src={Icons.savingsCoin} />
                                    <div className={styles.CommonSavingsBifurcation_savingsTitle}>
                                    <span className={styles.CommonSavingsBifurcation_totalSavingsValue}>₹{formatIndianNumber(cart?.discountedTotal + (deliveryCharges > 0 ? 150 : 0))} </span>
                                    Saved in this order
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className={styles.BillSummarySection_ellipseBottom} style={{ backgroundImage: `url(${IMG.ellipseWhite})` }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Checkout
